export const LoadingOne = () => {
  return (
    <div className="flex min-h-screen bg-base-200 flex-col items-center justify-center">
      <img
        className="w-[200px] animate-bounce"
        alt="robot thinking"
        src="/image/robot_thinking.png"
      />
      <div className="flex flex-row gap-2">
        <p>Chargement</p>
        <span className="loading loading-dots loading-lg"></span>
      </div>
    </div>
  );
};
